// extracted by mini-css-extract-plugin
var _1 = "_roles-module__btn-container";
var _2 = "_roles-module__title";
export { _1 as "btn-container", _2 as "title" }
